import { Box, Rhythm, Text } from '@trmediaab/zebra';
import { connect } from 'react-redux';

import AuthorItem from './AuthorItem';
import { authorIds } from './saga';
import { selectAuthors } from './selector';

function FrontpageAuthorsList({ authors }) {
  return (
    <Box pt="28px">
      <Text fontSize={3} fontWeight="bold">
        Våra krönikörer
      </Text>

      <Rhythm between="1" mt="3">
        {authorIds
          .map(id => authors[id]?.data)
          .filter(Boolean)
          .map(author => (
            <AuthorItem key={author.slug} author={author} />
          ))}
      </Rhythm>
    </Box>
  );
}

const mapStateToProps = state => ({
  authors: selectAuthors(state),
});

export default connect(mapStateToProps)(FrontpageAuthorsList);
